import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { PatrimonioDeudaNacionalModalComponent } from '../modales/patrimonio/patrimonio-deuda-nacional-modal/patrimonio-deuda-nacional-modal.component';
import { PatrimonioDeudasExtranjeraModalComponent } from '../modales/patrimonio/patrimonio-deudas-extranjera-modal/patrimonio-deudas-extranjera-modal.component';
import { PatrimonioDeudasAntModalComponent } from '../modales/patrimonio/patrimonio-deudas-anteriores-modal/patrimonio-deudas-anteriores-modal.component';
import { DDocumento } from '@dian/api-formulario';
import { HandlerComponent, Question } from '../handler-component';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DTasaCambioCompleto } from '@dian-api/renta210v18';
import { DialogoConfirmacionComponent } from '../../../table-items/dialogo-confirmacion/dialogo-confirmacion.component';
import { ComponentFactoryService } from '../../../../services/component-factory.service';
import { RentasLiquidasGravablesComponent } from '../modales/impuesto-renta/rentas-liquidas-gravables-modal/rentas-liquidas-gravables-modal.component';


const questions:Question[] = [
  {
    question: 'A diciembre 31 ¿tuvo deudas en moneda nacional?', 
    field: 'cs_id_167', show:true, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "1", totalField: "cs_id_168"
  },
  {
    question: 'A diciembre 31 ¿tuvo deudas en moneda extranjera?', 
    field: 'cs_id_169', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_170"
  },
  {
    question: '¿Declaró alguna deuda en periodos anteriores sin los debidos soportes legales (títulos valor)?', 
    field: 'cs_id_171', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_172"
  }
];


@Component({
  selector: 'app-mis-deudas',
  templateUrl: './mis-deudas.component.html',
  styleUrls: ['./mis-deudas.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class MisDeudasComponent extends HandlerComponent implements OnInit {

  @Input('model') model: DDocumento = new DDocumento();
  @Input('tablaArt73') tablaArt73:any;
  @Input('listaMoneda') listaMoneda:any;
  @Input('lisTipDeudaMonNal') lisTipDeudaMonNal:any;
  @Input('listaModoAdquision') listaModoAdquision: any;  
  @Input('listaOrigenInformacion') listaOrigenInformacion: any;
  @Output('isCompleted') isCompleted: EventEmitter<boolean> = new EventEmitter<false>();
  @Output('saveModel') saveModel: EventEmitter<boolean> = new EventEmitter<false>();
  @Output('getTRM') getTRM: EventEmitter<DTasaCambioCompleto> = new EventEmitter<DTasaCambioCompleto>();

  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    private _componentFactory: ComponentFactoryService,
    private dialog: MatDialog    
  ) { 
    super(questions);
  }

  ngOnInit() {
    this.initilizeQuestionsDesdeModelo(this.model);
    this.initializeSiTieneSugerida();
  }

  validateQuestions(id: number) {
    console.log(id);
  }

  questionHasSugerida(index: number) {
    return questions[index].hasSuggested == "1";
  }
  /**
   * Inicializa las respuestas en Sí si la sección tiene sugerida
   */
  initializeSiTieneSugerida(){
    for (let numPregunta = 0; numPregunta < questions.length; numPregunta++) {
      if (this.questionHasSugerida(numPregunta) && questions[numPregunta].resp!="0") {
        questions[numPregunta].resp='1';
        this.model.doc.cuerpo[questions[numPregunta].field]="1";
      }
    }
  }

  initilizeQuestionsDesdeModelo(model){
    for (let i = 0; i < questions.length; i++) {
      questions[i].resp = model.doc.cuerpo[questions[i].field];
      questions[i].isCompleted = this.validateModalCompleted(i);
      if (questions[i].isCompleted || model.doc.cuerpo[questions[i].field] == "1") { questions[i].show = true; }
      this.checkNextQuestion(i);
    }
  }

  openModal(indexQuestionModal:number) {
    const configSinSugerida = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: this.model
    };
    const configSugerida = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: {
        model: this.model
      }
    }
    let config;
    if(this.questionHasSugerida(indexQuestionModal)){
      config = configSugerida;
    }else{
      config = configSinSugerida;
    }
    
    switch (indexQuestionModal) {
      case 0:
        let dialog1 = this.dialog.open(PatrimonioDeudaNacionalModalComponent, config);
        dialog1.componentInstance.lisTipDeudaMonNal = this.lisTipDeudaMonNal;
        dialog1.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog1.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 1:
        let dialog2 = this.dialog.open(PatrimonioDeudasExtranjeraModalComponent, config);
        dialog2.componentInstance.listaMoneda = this.listaMoneda;
        dialog2.componentInstance.getTRM.subscribe(data => {
          this.getTRM.emit(data);
        });
        dialog2.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog2.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 2:
        let dialog3 = this.dialog.open(PatrimonioDeudasAntModalComponent, config);
        dialog3.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog3.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
    }
    
  }

  protected validateModalCompleted(indexQuestion:number):boolean{
    let isModalComplete: boolean = false;
    let valCasTotal = this.model.doc.cuerpo[questions[indexQuestion].totalField] ? this.model.doc.cuerpo[questions[indexQuestion].totalField].toString() : "0";
    if ((this.model.doc.cuerpo[questions[indexQuestion].field] != undefined && this.model.doc.cuerpo[questions[indexQuestion].field] == "0") ||
          this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCasTotal, "0")) {
      isModalComplete = true;
    }
    if(isModalComplete){
      questions[indexQuestion].isCompleted = true;
      if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = true;//Habilitar visibilidad de la siguiente pregunta
    }else{
      questions[indexQuestion].isCompleted = false;
      //if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = false;
    }
    this.validateComponentCompleted();
    return isModalComplete;
  }
  
  public validateComponentCompleted(): boolean{
    for(let i=0; i < questions.length; i++){
      if(questions[i].isCompleted==false){
        this.isCompleted.emit(false);
        return false;
      }
    }
    this.isCompleted.emit(true);//Componente completo!
    return true;
  }

  protected validateHasModalValues(indexQuestion:number):boolean{
    let hasValues:boolean = false;
    let valCasTotal = this.model.doc.cuerpo[questions[indexQuestion].totalField] ? this.model.doc.cuerpo[questions[indexQuestion].totalField].toString() : "0";
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCasTotal, "0")) {
      hasValues = true;
    }
    return hasValues;
  }

  protected cleanModalValues(indexQuestionModal:number){
    switch(indexQuestionModal){
      
      case 0:
        this.model.doc.cuerpo.cc_id_252=[];
        this.model.doc.cuerpo.cc_id_253=[];
        this.model.doc.cuerpo.cc_id_254=[];
        this.model.doc.cuerpo.cc_id_173=[];
        this.model.doc.cuerpo.cs_id_168="0";//Suma total
      break;
      case 1:
        this.model.doc.cuerpo.cc_id_262 = [];
        this.model.doc.cuerpo.cc_id_263 = [];
        this.model.doc.cuerpo.cc_id_264 = [];
        this.model.doc.cuerpo.cc_id_265 = [];
        this.model.doc.cuerpo.cc_id_266 = [];
        this.model.doc.cuerpo.cc_id_267 = [];
        this.model.doc.cuerpo.cs_id_170="0";//Suma total
        break;
      case 2:
          this.model.doc.cuerpo.cc_id_271 = [];
          this.model.doc.cuerpo.cc_id_272 = [];
          this.model.doc.cuerpo.cs_id_172="0";//Suma total
      break;
    }
    this.dependenciaTarjetas(indexQuestionModal);
    this.saveModel.emit(true);

    console.log(this.model);
  }

  changeValue(data: any, index: number) {
    questions[index].resp = data.value.toString();
    this.model.doc.cuerpo[data.field] = data.value.toString();
    if (this.model.doc.cuerpo[data.field] == "0") {
      if (this.questionHasSugerida(index)) {
        const dialogRef = this.dialog.open(DialogoConfirmacionComponent, {
          data: {
            mensaje1: 'Usted tiene información sugerida para esta pregunta',
            mensaje2: 'Puede revisarla u omitirla para continuar con la siguiente pregunta.',
            botonTrue: 'Revisar',
            botonFalse: 'Omitir'
          }
        });
        dialogRef
          .afterClosed().subscribe(res => {

            if (res) { 
              this.model.doc.cuerpo[data.field] = "1";//restaura el radio button a Sí
              this.validateModalCompleted(index);
              this.saveModel.emit(true);
              this.openModal(index);
              questions[index].resp="1";
              return;//sale sin mostrar el segundo modal que pregunta si quiere eliminar los datos
            }else{
              this.validateModalCompleted(index);
            }
            this.askIfDeleteModalData(index, data);
            
          });
          
      }else{
        this.validateModalCompleted(index);
        this.askIfDeleteModalData(index, data);
      }
      
    } else if (this.model.doc.cuerpo[data.field] == "1") {
      questions[index].isCompleted = false;
      this.validateModalCompleted(index);//Valida antes de abrir el modal por si ya lo había completado para que siga mostrándolo completo
      this.openModal(index);
      this.saveModel.emit(true);
    }
    this.checkNextQuestion(index);
    this.validateComponentCompleted();
  }




  private askIfDeleteModalData(index: number, data: any) {
    if (this.validateHasModalValues(index)) {

      const dialogRef2 = this.dialog.open(DialogoConfirmacionComponent, {
        data: {
          mensaje1: '¿Está seguro de eliminar esta información?',
          mensaje2: 'Al hacerlo no podrá recuperarla.',
          botonTrue: 'Sí',
          botonFalse: 'No'
        }
      });
      dialogRef2
        .afterClosed().subscribe(result => {
          if (result) { //si desea eliminar el contenido del modal
            questions[index].isCompleted = true;
            this.cleanModalValues(index);
            this.validateModalCompleted(index);
            this.saveModel.emit(true);
          } else { //no desea eliminar el contenido del modal
            questions[index].resp="1";
            this.model.doc.cuerpo[data.field] = "1";
            this.validateModalCompleted(index);
            this.saveModel.emit(true);
          }
        });
    } else {
      questions[index].isCompleted = true;
      this.cleanModalValues(index);
      this.validateModalCompleted(index);
      this.saveModel.emit(true);
    }
  }
  dependenciaTarjetas(indexQuestionModal:number)
  {
    switch (indexQuestionModal) {
      case 0:
        break;
      case 1:
        break;
      case 2:
        const componentRentaLiqGravable= this._componentFactory.createModalComponent(RentasLiquidasGravablesComponent, this.model);
        componentRentaLiqGravable.instance.initializeTablaDesdeModelo();
        break;
    }
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/mis-deudas/mis-deudas.component.ts